import React, {Component} from 'react'
import {Modal, Row} from 'antd'
import BillLinesList from './BillLinesList'
import {round, sum} from 'lodash'
import {numVal} from '../../../../../../modules/Utils'
import FilterForm from '../../../../../../components/Operations/Transport/InService/FilterForm'

class InvoiceModal extends Component {
  render() {
    const {
      visibleInvoice,
      onCancelInvoice,
      invoiceFormRef,
      invoiceBooking,
      invoicing,
      billLines,
    } = this.props
    return (
      <Modal
        visible={visibleInvoice}
        title={'Invoice All'}
        destroyOnClose={true}
        confirmLoading={invoicing}
        onOk={invoiceBooking}
        onCancel={onCancelInvoice}
        okButtonProps={{
          disabled: sum(billLines.map(d => numVal(d, 'paid'))) <= 0,
        }}
        width={'90%'}
        okText={'Request Invoice'}>
        <Row>
          <FilterForm ref={invoiceFormRef} {...this.props} />
        </Row>
        <Row>
          <BillLinesList {...this.props} />
        </Row>
      </Modal>
    )
  }
}

InvoiceModal.propTypes = {}
InvoiceModal.defaultProps = {}

export default InvoiceModal
